import React, { useState } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { DashboardTable } from '../DataTables';
import "./ShowUserDataDrawer.scss"
import moment from 'moment';
const ShowUserDataDrawer = ({ isOpen, userId, onClose }) => {
    // Function to close the drawer
    console.log(userId, "userId")

    const [pickerDates, setPickerDates] = useState({
        startDate: 'Select',
        endDate: 'dates',
    });
    const handleEvent = (event, picker) => {
        setPickerDates({
            startDate: picker.startDate.format('YYYY-MM-DD'),
            endDate: picker.endDate.format('YYYY-MM-DD'),
        });
    };
    const onDateCanceled = () => {
        setPickerDates({ startDate: 'Select', endDate: 'dates' });
    };
    const handleSelect = () => {
        const today = new Date();
        const lastWeek = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() - 7
        );

        const startDate = lastWeek.toISOString().substring(0, 10);
        const endDate = today.toISOString().substring(0, 10);

        setPickerDates({
            startDate: startDate,
            endDate: endDate,
        });
    };
    const handleLastdaysData = (days) => {
        console.log(days, 'dashbDays');
        if (days === 'all') {
            onDateCanceled();
        } else {
            let date = new Date();
            const endDate = moment(date).format('YYYY-MM-DD');

            const startDate = moment(date)
                .subtract(days - 1, 'days')
                .format('YYYY-MM-DD');

            setPickerDates({
                startDate: startDate,
                endDate: endDate,
            });
        }
    };

    return (
        <Drawer anchor="right" open={isOpen} onClose={onClose} PaperProps={{ style: { width: '60%' } }}>
            <div className='show-user-data-drawer-container'>
                {/* Drawer content */}
                <div className="show-user-data-drawer-recent-scans">
                    <DashboardTable
                        userId={userId}
                        handleDate={handleEvent}
                        handleCancel={onDateCanceled}
                        pickerDates={pickerDates}
                        handleSelect={handleSelect}
                        handleLastDays={handleLastdaysData}
                    />
                </div>
                <div className='show-user-data-drawer-close-btn-container' >
                    <div className='show-user-data-drawer-close-btn' onClick={onClose}>Close</div>
                </div>
            </div>
        </Drawer>
    )
}

export default ShowUserDataDrawer